// extracted by mini-css-extract-plugin
export var buttonsWrapper = "social-video-module--buttonsWrapper--cd7d5";
export var controlButton = "social-video-module--controlButton--995b0";
export var infoInner = "social-video-module--infoInner--14acb";
export var infoWrapper = "social-video-module--infoWrapper--dc495";
export var playButton = "social-video-module--playButton--7f61e";
export var pulse = "social-video-module--pulse--9f217";
export var videoWrapper = "social-video-module--videoWrapper--64a19";
export var wrapper = "social-video-module--wrapper--7a6f1";